import React from 'react';
import { Alerts } from '../../reusableComponents';
import PropsDescription from '../../components/PropsDescription/PropsDescription';

export default function AlertsContainer() {
  const alertsProps = [
    {
      name: 'children',
      type: 'node',
      notes: 'Content to display in the alert',
    },
    {
      name: 'type',
      type: 'string',
      notes: 'Type of alert: "message", "success", "warning", or "error". Default: "message"',
    },
    {
      name: 'dismissible',
      type: 'boolean',
      notes: 'Whether the alert can be dismissed. Default: false',
    },
  ];

  return (
    <div className="page-component-spacing">
      <h4>Alerts</h4>

      <div style={{ marginBottom: '20px' }}>
        <h5>Message Alert</h5>
        <Alerts type="message">This is a message alert. It provides general information to the user.</Alerts>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h5>Success Alert</h5>
        <Alerts type="success">This is a success alert. The action was completed successfully!</Alerts>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h5>Warning Alert</h5>
        <Alerts type="warning">This is a warning alert. Please review this information carefully.</Alerts>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h5>Error Alert</h5>
        <Alerts type="error">This is an error alert. Something went wrong with your request.</Alerts>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h5>Dismissible Alert</h5>
        <Alerts
          type="success"
          dismissible
        >
          This is a dismissible alert. Click the X button to close it.
        </Alerts>
      </div>

      <div className="page-component-spacing">
        <PropsDescription componentProps={alertsProps} />
      </div>
    </div>
  );
}
